import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IndividualMasterCreateRequestDTO, IndividualMasterDeleteRequestDTO, IndividualMasterDTO, IndividualMasterList, IndividualMasterReadAllPaginatedRequestDTO, IndividualMasterReadByIdRequestDTO, IndividualMasterReadByUserIdRequestDTO, IndividualMasterSearchByNameRequestDTO, IndividualMasterUpdateRequestDTO } from './individual.interface';
import { IndividualMaster_create, IndividualMaster_delete, IndividualMaster_readAll, IndividualMaster_readAllPaginated, IndividualMaster_readById, IndividualMaster_readByUserId, IndividualMaster_searchByName, IndividualMaster_update } from 'src/app/GlobalVariables';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class IndividualService {
  [x: string]: any;

  http = inject(HttpClient)

  constructor() { }

  IndividualMaster_create(data: IndividualMasterCreateRequestDTO): Observable<IndividualMasterDTO> {
      return this.http.post<IndividualMasterDTO>(IndividualMaster_create, data)
  }

  IndividualMaster_update(data: IndividualMasterUpdateRequestDTO): Observable<IndividualMasterDTO> {
    return this.http.post<IndividualMasterDTO>(IndividualMaster_update, data)
  }
  
  IndividualMaster_readAll(): Observable<IndividualMasterList> {
    return this.http.get<IndividualMasterList>(IndividualMaster_readAll)
  }
  IndividualMaster_delete(data: IndividualMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(IndividualMaster_delete, data)
  }
  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-users tab).
  // Omitted for every other caller - behaves exactly as before.
  IndividualMaster_readAllPaginated(data: IndividualMasterReadAllPaginatedRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<IndividualMasterList> {
    return this.http.post<IndividualMasterList>(resolveTenantUrl(IndividualMaster_readAllPaginated, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }

  IndividualMaster_readByUserId(data: IndividualMasterReadByUserIdRequestDTO): Observable<IndividualMasterDTO> {
    return this.http.post<IndividualMasterDTO>(IndividualMaster_readByUserId, data)
  }

  IndividualMaster_searchByName(data:IndividualMasterSearchByNameRequestDTO): Observable<IndividualMasterList> {
    return this.http.post<IndividualMasterList>(IndividualMaster_searchByName, data)
  }

    IndividualMaster_readById(data: IndividualMasterReadByIdRequestDTO): Observable<IndividualMasterDTO> {
    return this.http.post<IndividualMasterDTO>(IndividualMaster_readById, data)
  }


}
